import React from 'react';
import PropTypes from 'prop-types';
import UserProp from '../../../../commonComponents/propTypes/userProp';
import { displayUserName } from '../../../../services/utilityFunctions';

function UserItem(props) {
  const { title, user, wrapperClass, showPhone } = props;

  const { image, phone } = user;
  const imageToShow = image?.thumb || '/images/no_user.png';
  const name = displayUserName(user);

  return (
    <div className="user-wrapper">
      {title ? <h5 className="user-title">{title}</h5> : null}
      <div className={`user-card ${wrapperClass}`}>
        <img src={imageToShow} alt={name} />
        <div className="user-info">
          <p className="user-name">{name}</p>
          {showPhone ? <p className="user-phone">{phone}</p> : null}
        </div>
      </div>
    </div>
  );
}

UserItem.propTypes = {
  title: PropTypes.string,
  user: PropTypes.shape(UserProp.propType).isRequired,
  wrapperClass: PropTypes.string,
  showPhone: PropTypes.bool,
};

UserItem.defaultProps = {
  title: null,
  wrapperClass: '',
  showPhone: false,
};

export default UserItem;
